import {FormattedMessage, useIntl} from 'react-intl'
import {Grid2 as Grid} from '@mui/material'
import {LicenseEntity} from './definition'
import {formatGoTime} from './utils'
import {CardProperty} from './CardProperty'

export interface LicenseCardProps {
  license: LicenseEntity
}

export const LicenseCard = (props: LicenseCardProps) => {
  const intl = useIntl()
  return (
    <>
      <Grid container columns={2}>
        <Grid size={1}>
          <CardProperty
            label={
              <FormattedMessage
                id='LicenseApp.Property.Customer'
                defaultMessage='Customer'
                description='Title of the customer property in the card and info dialog'
              />
            }
          >
            {props.license.parsed.customer}
          </CardProperty>
        </Grid>
        <Grid size={1}>
          <CardProperty
            label={
              <FormattedMessage
                id='LicenseApp.Property.Expiration'
                defaultMessage='Expiration'
                description='Title of the expiration property in the card and info dialog'
              />
            }
          >
            {formatGoTime(props.license.parsed.expiration, intl) ?? '-'}
          </CardProperty>
        </Grid>
        <Grid size={1}>
          <CardProperty
            label={
              <FormattedMessage
                id='LicenseApp.Property.Description'
                defaultMessage='Description'
                description='Title of the description property in the card and info dialog'
              />
            }
          >
            {props.license.parsed.description}
          </CardProperty>
        </Grid>
      </Grid>
    </>
  )
}
